import { Chip, Paper, MenuItem, Select, CircularProgress} from "@mui/material";
import Alert from "@mui/material/Alert";
import axios from "axios";
import * as React from "react";
import { Config } from "../../../config/config";
import { Helpers } from "../../../utils/helpers";
import { PopupMessage } from "../../../utils/message";

interface Props {
    playerId: string;
    activeEnv: any;
    heroesConfig: any;
    classes?: any;
    form?: any;
    playerData: any;
    fetchData(): void;
    data: any;
    config: any;
}

export class PlayerDailyGifts extends React.Component<Props, any> {
    constructor(props) {
        super(props);
        this.state = {
            loadingItemId: ''
        }
    }

    updateStatus = async (event, dailyGiftId) => {
        try {
            this.setState({
                loadingItemId: dailyGiftId
            })
            const { value } = event.target;
            console.log('status === ', value)
            await axios.put(`${Config.getInstance.apiUrl}/api/user/${this.props.playerId}/daily_gift/${dailyGiftId}`, {
                status: value,
            }, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                    env: this.props.activeEnv,
                },
            });
            this.props.fetchData();
            this.setState({
                loadingItemId: ''
            })
        } catch (error) {
            PopupMessage.error("Something went wrong");
        }
    }

    displayGift = (item: any, config: any, type: "ranked" | "ruby") => {
        return <Paper className={`dailyJobs--item`} key={item.id} elevation={0}>
            <div style={{ padding: "15px 10px", margin: "10px", overflow: "hidden" }}>
                <div style={{ float: "left" }}>
                    <div>[<b>{item.key}</b>] {Helpers.getLocalizationName(`${item.key}`)}</div>
                </div>
                <div style={{ float: "right", paddingRight: 15, paddingTop: 5 }}>
                    <div style={{ paddingLeft: 25, display: "inline-block" }}>
                        {Helpers.conditionPrint(!this.props.playerData.is_online, <span>{item.status}</span>, "")}
                        {Helpers.conditionPrint(this.props.playerData.is_online,
                            <>
                                {this.state.loadingItemId === item.id && <CircularProgress />}
                                {this.state.loadingItemId !== item.id && <Select
                                    labelId="status-select-label"
                                    value={item.status}
                                    onChange={e => this.updateStatus(e, item.id)}
                                >
                                    <MenuItem value="inactive">In Active</MenuItem>
                                    <MenuItem value="inProgress">In Progress</MenuItem>
                                    <MenuItem value="completed">Completed</MenuItem>
                                    <MenuItem value="claimed">Claimed</MenuItem>
                                </Select>}
                            </>, "")}
                    </div>
                </div>
            </div>
        </Paper>;
    } 

    render() {
        const dailyGifts = this.props.data.dailyGifts || [];
        console.log('dailyGifts === ', this.props.data)
        return (
            <React.Fragment>
                 <div style={{ borderWidth: 1, borderRadius: 5 }}>
                    <Chip label={"DAILY GIFT"}/>
                    {dailyGifts.map(item => this.displayGift(item, this.props.config, "ranked"))}
                    {dailyGifts.length === 0 && <Alert severity="info">
                        No ranked daily challenges
                    </Alert>}
                </div>
            </React.Fragment>
        );
    }
}